import { c as classNames } from './index-b0444989.js';
import React__default, { useRef, useEffect, useState } from 'react';
import { u as useIsomorphicLayoutEffect, a as useTimeout, P as ProgressRing } from './index-24c54d4a.js';
import { _ as __rest, a as __assign } from './tslib.es6-ff7ae7b8.js';
import './countries-0aa398a1.js';
import { Card } from './es/components/Card.js';
import { Typography } from './es/components/Typography.js';

function CircleCheckIcon(_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React__default.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React__default.createElement("path", { d: "M12.8169 0C10.4435 0 8.12345 0.703788 6.15006 2.02236C4.17667 3.34094 2.6386 5.21508 1.73035 7.4078C0.822094 9.60051 0.584454 12.0133 1.04748 14.3411C1.5105 16.6689 2.65339 18.807 4.33162 20.4853C6.00985 22.1635 8.14804 23.3064 10.4758 23.7694C12.8036 24.2324 15.2164 23.9948 17.4091 23.0865C19.6018 22.1783 21.476 20.6402 22.7945 18.6668C24.1131 16.6934 24.8169 14.3734 24.8169 12C24.8108 8.81927 23.5446 5.77057 21.2954 3.52146C19.0463 1.27234 15.9976 0.0060992 12.8169 0ZM18.5284 9.9L11.7669 16.3615C11.5921 16.526 11.3607 16.6169 11.1207 16.6154C11.0034 16.6171 10.887 16.5955 10.778 16.5519C10.6691 16.5084 10.5699 16.4436 10.4861 16.3615L7.10536 13.1308C7.01159 13.049 6.93533 12.949 6.88116 12.837C6.827 12.725 6.79604 12.6031 6.79016 12.4788C6.78428 12.3545 6.80359 12.2303 6.84694 12.1137C6.89029 11.997 6.95677 11.8903 7.0424 11.8C7.12803 11.7097 7.23103 11.6377 7.34521 11.5882C7.4594 11.5387 7.58241 11.5129 7.70685 11.5121C7.83129 11.5114 7.95459 11.5359 8.06934 11.584C8.18409 11.6322 8.28792 11.703 8.37459 11.7923L11.1207 14.4115L17.2592 8.56154C17.4387 8.40495 17.6718 8.3238 17.9097 8.33505C18.1476 8.34631 18.372 8.4491 18.5359 8.62194C18.6998 8.79477 18.7905 9.02427 18.7891 9.26246C18.7877 9.50065 18.6943 9.72908 18.5284 9.9Z", fill: fillColor })));
}

// https://usehooks-ts.com/react-hook/use-interval
function useInterval(callback, delay) {
    var savedCallback = useRef(callback);
    // Remember the latest callback if it changes.
    useIsomorphicLayoutEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    useEffect(function () {
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) {
            return;
        }
        var id = setInterval(function () { return savedCallback.current(); }, delay);
        return function () { return clearInterval(id); };
    }, [delay]);
}

var styles = {"container":"LoadingPanto_container_f21a271c","header":"LoadingPanto_header_f21a271c","itemsContainer":"LoadingPanto_itemsContainer_f21a271c","items":"LoadingPanto_items_f21a271c","active":"LoadingPanto_active_f21a271c","doneIcon":"LoadingPanto_doneIcon_f21a271c","complete":"LoadingPanto_complete_f21a271c"};

var ItemLabel = function (_a) {
    var state = _a.state, index = _a.index, item = _a.item;
    if (state < index) {
        return React__default.createElement(React__default.Fragment, null, item.beforeStart);
    }
    else if (state === index) {
        return React__default.createElement(React__default.Fragment, null, item.inProgress);
    }
    else
        return React__default.createElement(React__default.Fragment, null, item.onComplete);
};
var LoadingPanto = function (_a) {
    var title = _a.title, items = _a.items, _b = _a.delay, delay = _b === void 0 ? 1500 : _b, onComplete = _a.onComplete;
    var _c = useState(0), state = _c[0], setState = _c[1];
    useInterval(function () {
        setState(state + 1);
    }, state < items.length ? delay : null);
    useTimeout(function () {
        onComplete();
    }, delay * items.length + delay);
    return (React__default.createElement(Card, { className: styles.container },
        React__default.createElement(Typography, { as: "h3", variant: "heading_xl", className: styles.header }, title),
        React__default.createElement(ProgressRing, { radius: 34, stroke: 4, type: "time", animationProps: {
                time: 1500 * items.length,
            }, className: styles.progress }),
        React__default.createElement("div", { className: styles.items }, items.map(function (item, i) {
            return typeof item === "string" ? (React__default.createElement("div", { key: item, className: styles.itemsContainer },
                React__default.createElement(CircleCheckIcon, { className: classNames(styles.doneIcon, state > i && styles.complete) }),
                React__default.createElement(Typography, { as: "p", className: state === i ? styles.active : undefined }, item + (state === i ? "..." : "")))) : (React__default.createElement("div", { key: i, className: styles.itemsContainer },
                React__default.createElement(CircleCheckIcon, { className: classNames(styles.doneIcon, state > i && styles.complete) }),
                React__default.createElement(Typography, { as: "p", className: state === i ? styles.active : undefined },
                    React__default.createElement(ItemLabel, { state: state, item: item, index: i }))));
        }))));
};

export { CircleCheckIcon as C, LoadingPanto as L };
